<template>
  <v-card class="card--flex-toolbar">
    <v-card-title primary-title>
      <div>
        <div class="headline secondary--text">
          {{ $t('company.create.title') }}
        </div>
        <span class="body-1 greyDarken1--text">Create a new company here</span>
      </div>
      <v-spacer></v-spacer>
      <v-tooltip left color="white">
        <template v-slot:activator="{on}">
          <v-icon slot="activator" v-on="on"
            >$vuetify.icons.rms_help_circle</v-icon
          >
        </template>
        <span class="greyDarken3--text body-1"
          >A comapny that manages films and rights</span
        >
      </v-tooltip>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" onsubmit="return false;">
        <v-text-field
          id="title"
          :label="$t('rms.field.title.label')"
          placeholder="My Comapny"
          name="title"
          color="primary"
          :rules="[rules.required, rules.min_length(6)]"
          prepend-icon="$vuetify.icons.rms_bank"
          type="text"
          v-model="title"
          @keyup.enter="create"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions class="pb-4">
      <v-spacer></v-spacer>
      <v-btn @click="create" color="secondary" dark>{{
        $t('rms.button.create')
      }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import rules from '@/validation';
export default {
  name: 'CreateCompany',
  data() {
    return {
      rules,
      title: null,
    };
  },

  methods: {
    async create() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      try {
        var data = await this.$store.dispatch('company/create', {
          title: this.title,
        });
        this.$store.dispatch('company/onAfterCreate', data);
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },
  },
};
</script>
